// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1WkUh","footer":"ReportModalFilter_footer__3Qjeg"};